import { formatDate } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { RemindersService } from 'api-services/reminders.service';
import { Subscription } from 'rxjs';
import { AuthService, SharedService } from 'services';
import { RoleService } from 'services/role.service';
import { ngbModalOptions, ReminderType, tenantTypeCap } from 'shared/constant';
import { SetRemindersComponent } from './set-reminders/set-reminders.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactService } from 'api-services/contact.service';
import { GridStateService } from 'services/grid-state.service';

@Component({
  selector: 'app-reminders',
  templateUrl: './reminders.component.html',
  styleUrls: ['./reminders.component.css']
})
export class RemindersComponent implements OnInit {
  @Input() reminderDetails = null;
  @Input() contactInfo = null;
  reminderList: any;
  reminderFilteredList: any;
  isToggleChecked: boolean = false;
  @Output() hideReminder = new EventEmitter<any>();
  @Output() updateCount = new EventEmitter<any>();
  requestedBy: number;
  isPast: boolean = false;
  status: boolean = false;
  isLoader: boolean = true;
  reminderTypeList = [
    { id: false, status: "Active Reminders" },
    { id: true, status: "Dismissed Reminders" }
  ]
  selectedReminderTypeId: number = 0;
  userAppointmentId: number = 0
  userLicenseClassId: number = 0
  branchId: number = 0
  eandOId: number = 0;
  requesteTypeList: any;
  userId: number = 0;
  isMenuOpen: { [key: number]: boolean } = {};
  tenantTypeId = localStorage['tenantTypeId'];
  tenantTypeCap = tenantTypeCap;
  subscription: Subscription[] = [];
  loginUserId = JSON.parse(localStorage["userId"]);
  isTenantOwnerUser: boolean = false;
  isIndividualUser: boolean = false;
  isContactUser: boolean = false;
  message = '';
  filterMessage = ''
  ReminderType = ReminderType;
  dueTodayCount = 0;
  today = new Date();
  gridStateName: string = "reminder-list";
  scrollTop: number = 0;
  selectedRecordId: number = null;

  constructor(private remindersService: RemindersService, private router: Router, private modalService: NgbModal,
    private sharedService: SharedService, private roleService: RoleService, private contactService: ContactService,
    private gridStateService: GridStateService, private authService: AuthService) {

  }

  ngOnInit(): void {
    this.isTenantOwnerUser = this.roleService.isTenantOwnerUser;
    this.isIndividualUser = this.roleService.isIndividualUser;
    this.isContactUser = this.roleService.isContactUser;

  
    let reminderTypeProducerName = this.tenantTypeCap[this.tenantTypeId]+'s';
    let reminderTypeBranchName = this.tenantTypeId == 3 ? 'Branches' : 'Agencies';

    var messageForAccountType =
      this.isIndividualUser ? `Reminders can be added on Licenses and Appointments.` :
        this.isContactUser ? `Reminders can be added on Licenses, Appointments, E&O and Bonds.` :
          `Reminders can be added on ${reminderTypeProducerName}, Licenses, Appointments, ${reminderTypeBranchName}, E&O and Bonds.`;

    this.message = `${messageForAccountType}`;

    this.getReminderType();
    
  }

  @HostListener('document:click', ['$event'])

  handleOutsideClick(event: Event) {
    for (let key in this.isMenuOpen) {
      if (this.isMenuOpen.hasOwnProperty(key)) {
        this.isMenuOpen[key] = false;
      }
    }
  }

  toggleMenu(event: Event, reminderId: number) {
    event.stopPropagation();
    for (let key in this.isMenuOpen) {
      if (this.isMenuOpen.hasOwnProperty(key) && Number(key) != reminderId) {
        this.isMenuOpen[key] = false;
      }
    }
    this.isMenuOpen[reminderId] = !this.isMenuOpen[reminderId];
  }

  getReminderType() {
    this.subscription.push(this.remindersService.getReminderTypes().subscribe(
      (response) => {
        this.requesteTypeList = response;

        let reminderTypeProducerName = this.tenantTypeCap[this.tenantTypeId];
        let reminderTypeBranchName = this.tenantTypeId == 3 ? 'Branch' : 'Agency';

        this.requesteTypeList = this.requesteTypeList.map(x => {
          return {
            ...x,
            reminderTypeName: x.reminderTypeId == 1 ? reminderTypeProducerName : x.reminderTypeId == 4 ? reminderTypeBranchName : x.reminderTypeName
          }
        })

        var state = this.gridStateService.getState(this.gridStateName);
    if(state){
      this.isPast = state.isPast;
      this.selectedReminderTypeId = state.selectedReminderTypeId;
      this.isToggleChecked = state.isToggleChecked;

      this.filterMessage = this.isPast ? 'There are no Dismissed Reminders' : '';
      
    }

        if (this.reminderDetails == null)
          this.getReminderList(true);
        // this.selectedReminderTypeId = this.requesteTypeList.reminderTypeId;

      },
      (error) => {
        console.log(error);
      }
    ));
  }


    isToday(dateStr: string): boolean {
    const d = new Date(dateStr);
    return (
      d.getFullYear() === this.today.getFullYear() &&
      d.getMonth() === this.today.getMonth() &&
      d.getDate() === this.today.getDate()
    );
  }


  getReminderList(initLoad:boolean =false) {
    var requestedBy = this.sharedService.getValue("userId");
    if (this.reminderDetails != null) {
      this.userId = this.reminderDetails.userId;
      this.selectedReminderTypeId = this.reminderDetails.reminderTypeId;
      this.userAppointmentId = this.reminderDetails.reminderTypeId == 2 ? this.reminderDetails.userAppointmentId : 0;
      this.userLicenseClassId = this.reminderDetails.reminderTypeId == 3 ? this.reminderDetails.userLicenseClassId : 0;
      this.branchId = this.reminderDetails.reminderTypeId == 4 ? this.reminderDetails.branchId : 0;
      this.eandOId = this.reminderDetails.eandOId > 0 ? this.reminderDetails.eandOId : 0;
    }

    
    this.subscription.push(this.remindersService.getReminders(this.userId, requestedBy, this.isPast, this.selectedReminderTypeId, this.userAppointmentId, this.userLicenseClassId, this.branchId, this.eandOId).subscribe(
      (response) => {
        this.dueTodayCount = 0;
        this.reminderList = response.map(reminder => {
          if (reminder.reminderDate && this.isToday(reminder.reminderDate)) {
            this.dueTodayCount++;
          }
          return {
            ...reminder,
            formattedDate: this.getFormattedDate(reminder.reminderDate),
            remainingDaysClass: this.GetReminderDueDaysColor(reminder.reminderDate),
            reminderDetail: null,
            createdDate: this.sharedService.convertUTCTimeToLocalTime(reminder.createdDate),
            isDismissed: false,
            dismissedDate: this.sharedService.convertUTCTimeToLocalTime(reminder.dismissedDate),
            isExpanded: false
          };
        });
        // this.reminderFilteredList = this.reminderList;
        this.filterData();

        if (initLoad) {
          const state = this.gridStateService.getState(this.gridStateName);
          this.selectedRecordId = state?.selectedRecordId;
          if (state?.selectedRecordId) {
            setTimeout(() => {
              document.querySelector('.reminder-section')?.scrollTo({ top: state?.scrollTop });
            }, 100);
            this.reminderFilteredList?.length > 0 ? this.openBox(this.reminderFilteredList?.find(el => el.reminderId == this.selectedRecordId) ?? this.reminderFilteredList[0]) : this.isLoader=false;
          }else{
            this.reminderFilteredList?.length > 0 ? this.openBox(this.reminderFilteredList[0]) : this.isLoader=false;
          }
        }else{
            setTimeout(() => {
              document.querySelector('.reminder-section')?.scrollTo({ top: 0 });
            }, 100);
            this.reminderFilteredList?.length > 0 ? this.openBox(this.reminderFilteredList[0]) : this.isLoader=false;
          }

        
      },
      (error) => {
        console.log(error);
      }
    ));
  }


  filterData(){
    if(this.isToggleChecked){
        this.reminderFilteredList = this.reminderList.filter(reminder => reminder.reminderDate && this.isToday(reminder.reminderDate))

    }else{
      this.reminderFilteredList = this.reminderList;
    }
  }

  onReminderTypeChange(event: any) {
    this.selectedReminderTypeId = event;
    this.getReminderList();
  }

  onChange() {
    this.filterMessage = this.isPast ? 'There are no Dismissed Reminders' : '';
    this.getReminderList();

  }

  ngOnChanges(changes: SimpleChanges) {
    this.isLoader=true;
    changes['reminderDetails'].currentValue != null ? this.getReminderList() : '';
  }

  closeReminder() {
    this.sharedService.setUserReminderVisibility(false);
    this.sharedService.setAllReminderVisibility(false);

    this.hideReminder.emit(false);
  }

  getFormattedDate(dueDate: string): string {
    const today = new Date();
    const due = new Date(dueDate);

    const diffInTime = due.getTime() - today.getTime();
    const diffInDays = Math.ceil(diffInTime / 1000 / 60 / 60 / 24);

    if (diffInDays === 0) {
      return 'Today';
    } else if (diffInDays === 1) {
      return 'Tomorrow';
    } else {
      return formatDate(due, 'MMM dd, yyyy', 'en-US');
    }
  }

  openBox(reminder) {
    this.selectedRecordId = reminder.reminderId;
    this.reminderDetails == null ? this.setGridStatus() : '';
    
    this.reminderFilteredList.forEach(rm => rm.isExpanded = reminder.reminderId == rm.reminderId ? !rm.isExpanded : false);   

    if (reminder?.reminderDetail == null && reminder.isExpanded) {

      this.subscription.push(this.remindersService.getReminderDetails(reminder.reminderId, reminder.reminderTypeId).subscribe(
        (response) => {
          reminder.reminderDetail = response;
          reminder.reminderDetail.updatedDate = this.sharedService.convertUTCTimeToLocalTime(response.updatedDate),
          this.isLoader=false;
        },
        (error) => {
          console.log(error);
        }
      ))
    } 
    // else {
    //   reminder.reminderDetail = null;
    // }
  }
  

  dismissReminder(reminder, event) {
    event.stopPropagation();
    this.subscription.push(this.remindersService.DismissReminder(reminder.reminderId).subscribe(
      (response) => {
        if (response) {
          reminder['isDismissed'] = true;
          const index = this.reminderList.findIndex(em => em.reminderId == reminder.reminderId);
          // this.updateCount.emit(this.reminderList[index].formattedDate);
          this.remindersService.deleteReminderCount(reminder);
          this.remindersService.updateReminderCount(true);
          setTimeout(() => this.reminderList.splice(index, 1), 800)

          this.sharedService.showToastMessage("Reminder dismissed successfully");
        }
      }
    ))
  }

  redirectToDashboard(event, reminder) {
    event.stopPropagation();
    if(reminder.reminderTypeId == ReminderType.Producer || ((reminder.reminderTypeId == ReminderType.Appointment || reminder.reminderTypeId == ReminderType.License) && reminder.npnTypeID == 2)){
      this.openContactDashboard(reminder);
    }else{
      this.openFirmDashboard(reminder);
    }
  }

  redirectToDetailview(event, reminder) {
    this.selectedRecordId = reminder.reminderId;
    event.stopPropagation();
    switch (reminder.reminderTypeId) {
      case 1:
        this.openContactDashboard(reminder);
        break;
      case 2:
        this.openAppointmentDetailView(reminder);
        break;
      case 3:
        this.openLicenseDetailView(reminder);
        break;
      case 4:
        this.openFirmDashboard(reminder);
        break;
      case 5:
        this.editEandO(reminder);
        break;
      case 6:
        this.editBond(reminder);
        break;

      default:
        break;
    }
  }

  openContactDashboard(reminder) {
    localStorage.setItem('activeContactUserId', reminder.userId.toString());
    this.sharedService.getBackURL('/contact-list');
    this.router.navigate(['/contact-dashboard']);
  }

  openLicenseDetailView(reminder){
    localStorage.setItem('licenseUserIds', JSON.stringify({userId: reminder.userId, userLicenseClassId: reminder.userLicenseClassId}));
    this.sharedService.getBackURL('/main-licenses');
    this.router.navigate(['main-licenses/license-detail']);
  }

  openAppointmentDetailView(reminder){
    localStorage.setItem('appointmentUserIds', JSON.stringify({userId: reminder.userId, userAppointmentId: reminder.userAppointmentId}));
    this.sharedService.getBackURL('/main-appointment');
    this.router.navigate(['main-appointments/appointment-detail']);
  }

  openFirmDashboard(reminder) {
    localStorage.setItem('activeContactUserId', reminder.userId.toString());
    localStorage.setItem('activeContactBranchId', reminder.branchId.toString());
    // localStorage.setItem('activeFirmNPNTypeId', license.npnTypeID.toString());
    this.sharedService.getBackURL('/manage/branches');
    this.router.navigate(['/firm-dashboard']);
  }

  editEandO(reminder){
    var eando = {eandOId: reminder.eandOId, eandOType: "E&O", policyType: reminder.eandoPolicyTypeId == 1 ? 'Firm' : 'Individual'}
    this.sharedService.sharedObj(eando);
    this.router.navigate(['errors-omissions/edit-eando']);
  }

  editBond(reminder){
    var bond = {eandOId: reminder.eandOId, eandOType: "Bond", policyType: reminder.eandoPolicyTypeId == 1 ? 'Firm' : 'Individual'}
    this.sharedService.sharedObj(bond);
    this.router.navigate(['errors-omissions/edit-bond']);
  }


  opensetReminderModal(){
    const modalRef = this.modalService.open(SetRemindersComponent, ngbModalOptions);
   
    modalRef.componentInstance.contactInfo = this.contactInfo;
    modalRef.result.then(data => {
      if(data){
         this.getReminderList(true);
         this.remindersService.updateReminderCount(true);
         this.contactInfo.totalReminderCount = Number(this.contactInfo.totalReminderCount) + 1;
      }
    });
    
  }

  editReminder(event, rl){
    event.stopPropagation();
    rl.reminderTypeId == ReminderType.Producer ? this.getResidentStateByUserId(rl): null;

    const modalRef = this.modalService.open(SetRemindersComponent, ngbModalOptions);
    var reminderInfo = {

      //For Update
      reminderId: rl.reminderId,
      description: rl.description,
      reminderDate: rl.reminderDate,
      ReminderTypeId: rl.reminderTypeId,
      userId: rl.userId,
      tenantId: rl.tenantId,
      branchId: rl.branchId,
      isPublic: rl.isPublic,
      autoExpire: rl.autoExpire,
      emailOnDueDate: rl.emailOnDueDate,
      eandOId: rl.eandOId,
      userLicenseClassId: rl.userLicenseClassId,
      userAppointmentId: rl.userAppointmentId,

      //For Display purpose.
      displayName: rl.name,
      npn: rl.reminderDetail.npn,
      residentStateName: null,
      licenseClass: rl.reminderDetail.licenseClassName,
      carrierName: rl.reminderDetail.carrierName,
      lineOfAuthorityName: rl.reminderDetail.lineOfAuthorityName,
      licenseNumber:rl.reminderDetail.licenseNumber,
      fein: rl.reminderDetail.fein,
      producerCode: rl.reminderDetail.producerCode,
      eandoPolicyTypeId: rl.reminderDetail.eandoPolicyTypeId
    }
   
    modalRef.componentInstance.contactInfo = reminderInfo;

    modalRef.result.then(data => {
     
      if (data) {
        rl.reminderDetail.description = data.description;
        rl.reminderDetail.updatedDate = new Date();
        rl.description = data.description;
        if (this.isToday(rl.reminderDate)) {
              if(!this.isToday(data.reminderDate))
                this.dueTodayCount--;
         }
        rl.formattedDate = this.getFormattedDate(data.reminderDate),
        rl.reminderDate = data.reminderDate;
        rl.isPublic = data.isPublic;
        rl.autoExpire = data.autoExpire;
        rl.emailOnDueDate = data.emailOnDueDate;
       
      }
    })
  }

  getResidentStateByUserId(rl){
    this.contactService.getResidenceStateOfUser(rl.userId, this.sharedService.getValue("tenantId"), false).subscribe(
      (response: any) => {
        rl.residentStateName =  response.stateName;
      },
      (error: any) => {
        console.log(error);
      }
    )
  }

  GetReminderDueDaysColor(dueDate: string): string{
    let currentDate = new Date();
    let due = new Date(dueDate);

    let diffInDays = Math.ceil((due.getTime() - currentDate.getTime()) / 1000 / 60 / 60 / 24);

    if (diffInDays == 0 || (diffInDays >= 0 && diffInDays <= 2)) {
      return "type-1";
    }
    else if (diffInDays >= 3 && diffInDays <= 6) {
      return "type-2";
    }
    else {
      return "type-3"
    }
  }

  onScroll(event: any) {
    this.scrollTop = event.target.scrollTop;
  }

  setGridStatus(){
     this.gridStateService.setState(this.gridStateName, {
      
      scrollTop: this.scrollTop,
      selectedRecordId: this.selectedRecordId,
      isPast: this.isPast,
      selectedReminderTypeId: this.selectedReminderTypeId,
      isToggleChecked: this.isToggleChecked
   
    });
  }

  ngOnDestroy(): void {
    this.subscription.forEach(t => { t.unsubscribe() });

    if (this.authService.isLoggingOut) {
      return;
    }

    this.reminderDetails == null ? this.setGridStatus() : '';

  }

  
}
